import React, { ReactNode } from "react";

export type ITheme = "dark" | "light" | "system";

export type IThemeProviderProps = {
  children: ReactNode;
  defaultTheme?: ITheme;
  storageKey?: string;
};

export type IThemeProviderState = {
  theme: ITheme;
  setTheme: (theme: ITheme) => void;
};

export const ThemeProviderContext = React.createContext<
  IThemeProviderState | undefined
>(undefined);
